  <div>
    <div class="form-group my-2">
      <label for="spouse-first-names" class="text-xs">What is your spouse's first name?</label>
      <input
        type="text"
        id="spouse-first-names"
        class="form-control"
        v-model="spouse_data.spouseFirstNames"
        placeholder="Enter spouse's first name"
      />
    </div>
    <div class="form-group my-2">
      <label for="spouse-middle-name" class="text-xs">What is your spouse's middle name?</label>
      <input
        type="text"
        id="spouse-middle-name"
        class="form-control"
        v-model="spouse_data.spouseMiddleName"
        placeholder="Enter spouse's middle name"
      />
    </div>
    <div class="form-group my-2">
      <label for="spouse-surname" class="text-xs">What is your spouse's surname?</label>
      <input
        type="text"
        id="spouse-surname"
        class="form-control"
        v-model="spouse_data.spouseSurname"
        placeholder="Enter spouse's surname"
      />
    </div>
    <div class="form-group my-2">
      <label for="spouse-id-type" class="text-xs">What is your spouse's identification type?</label>
      <select
        id="spouse-id-type"
        class="form-select"
        v-model="spouse_data.spouseIdType"
      >
        <option value="Not Selected">Not Selected</option>
        <option value="Valid Id">ID Number</option>
        <option value="Passport">Passport Number</option>
      </select>
    </div>
    <div v-if="spouse_data.spouseIdType !== 'Not Selected'" class="form-group my-2">
      <label for="spouse-id-no" class="text-xs">What is your spouse's ID number?</label>
      <input
        type="text"
        id="spouse-id-no"
        class="form-control"
        v-model="spouse_data.spouseIdNo"
        placeholder="Enter spouse's ID/Passport number"
      />
    </div>
    <div class="form-group my-2">
      <label for="spouse-date-of-birth" class="text-xs">What is your spouse's date of birth?</label>
      <input
        type="text"
        maxlength="8"
        @input="allow_num"
        id="spouse-date-of-birth"
        class="form-control"
        v-model="spouse_data.spouseDateOfBirth"
        placeholder="YYYYMMDD"
      />
    </div>
    <div class="form-group my-2">
      <label for="spouse-phone-number" class="text-xs">What is your spouse's mobile number?</label>
      <input
        type="text"
        id="spouse-phone-number"
        class="form-control"
        v-model="spouse_data.spousePhoneNumber"
        placeholder="Enter spouse's mobile number"
      />
    </div>
  </div>